import { render, staticRenderFns } from "./RightCenter.vue?vue&type=template&id=49f38de7&scoped=true"
import script from "./RightCenter.vue?vue&type=script&lang=js"
export * from "./RightCenter.vue?vue&type=script&lang=js"
import style0 from "./RightCenter.vue?vue&type=style&index=0&id=49f38de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f38de7",
  null
  
)

export default component.exports